/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import Analytics from "./util/Analytics";

import {
	LOAD,
	OPEN_PAYMENT_MODAL,
} from "ducks/incognito_packages";

// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function incognitoPackagesAnalytics(state, action) {
	switch (action.type) {
		case LOAD: {
			return;
		}

		case OPEN_PAYMENT_MODAL: {
			const { total, subPeriod } = action.payload;

			const options = {
				data: {
					"Plan duration in months": subPeriod,
					"gross proceeds in local currency": total / 100,
				},
			};

			Analytics.logUIEvent(
				Analytics.eventNames.purchasesSelectedPlanOnIncognitoUpsell,
				options
			);

			Analytics.logUIEvent(
				Analytics.eventNames.purchasesSelectedSubscribeOnIncognitoUpsell,
				options
			);

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/incognito_packages.js